<template>
  <div class="sci-page-wrapper" style="font-family: 'Inter', sans-serif;">
    <div class="max-w-7xl mx-auto space-y-8">
      
      <!-- HEADER -->
      <div class="sci-page-header pb-4">
        <div>
          <h1 class="sci-page-title-only">
            {{ $route.name }}
          </h1>
          <p class="text-sm text-slate-500 font-medium mt-1">
            Gerencie e acompanhe os abastecimentos da frota
          </p>
        </div>
      </div>

      <!-- FILTROS DE PESQUISA -->
      <section v-if="userGroup == 1" class="bg-white rounded-xl border border-slate-200 overflow-hidden shadow-sm mb-8">
          <div class="px-6 py-4 flex items-center gap-3" style="background-color: #333333;">
              <v-icon color="orange" small>mdi-magnify</v-icon>
              <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">
                  FILTROS DE PESQUISA
              </h2>
          </div>
          <div class="p-8">
              <v-row>
                  <v-col cols="12" sm="12" md="3">
                    <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Data Inicial</label>
                    <Date @dateValue="[(filter.startDate = $event)]" label="Data Inicial" />
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                    <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Data Final</label>
                    <Date @dateValue="[(filter.endDate = $event)]" label="Data Final" />
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                      <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Município</label>
                      <v-autocomplete
                        v-model="filter.prefecture_id"
                        :items="prefectures"
                        item-text="prefecture_social_name"
                        item-value="prefecture_id"
                        placeholder="SELECIONE O MUNICÍPIO..."
                        solo flat dense hide-details
                        class="bg-slate-50 border border-slate-200 rounded-lg"
                        height="44"
                        clearable
                        @change="onFilterPrefectureChange"
                        no-data-text="Nenhum município encontrado"
                      ></v-autocomplete>
                  </v-col>
                  <v-col cols="12" sm="12" md="3">
                      <label class="block text-[10px] font-bold text-slate-500 uppercase tracking-wider mb-2">Fornecedor</label>
                      <v-autocomplete
                        v-model="filter.provider_id"
                        :items="filterProviders"
                        item-text="provider_name"
                        item-value="provider_id"
                        placeholder="SELECIONE O FORNECEDOR..."
                        solo flat dense hide-details
                        class="bg-slate-50 border border-slate-200 rounded-lg"
                        height="44"
                        clearable
                        :disabled="!filter.prefecture_id"
                        no-data-text="Nenhum fornecedor encontrado"
                      ></v-autocomplete>
                  </v-col>
              </v-row>
              <div class="flex justify-end mt-8">
                  <button @click="initialize" class="bg-[#333333] hover:bg-slate-900 text-white rounded-lg shadow-md flex items-center justify-center gap-2 w-fit whitespace-nowrap px-10 h-10 transition-all transform hover:-translate-y-0.5 font-bold text-[11px] uppercase tracking-widest">
                      <v-icon color="orange" small class="mr-1" style="font-size: 14px;">mdi-filter-outline</v-icon>
                      FILTRAR RESULTADOS
                  </button>
              </div>
          </div>
      </section>

      <!-- DATA TABLE CARD -->
      <div class="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
        <div class="px-6 py-4 flex items-center justify-between" style="background-color: #333333;">
          <div class="flex items-center gap-3">
            <v-icon color="orange" small>mdi-gas-station</v-icon>
            <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">
              REGISTROS DE ABASTECIMENTO
            </h2>
          </div>

          <div class="flex items-center gap-4 flex-1 justify-end">
            <v-tooltip bottom color="indigo">
              <template v-slot:activator="{ on, attrs }">
                <button 
                  v-bind="attrs"
                  v-on="on"
                  @click="openExtraModal" 
                  class="bg-indigo-500 hover:bg-indigo-600 mr-2 text-white shadow-lg flex items-center justify-center gap-2 rounded-lg px-4 py-2 transition-all w-fit whitespace-nowrap"
                  style="width: auto !important; flex: none !important;"
                >
                  <v-icon color="white" x-small>mdi-gas-station</v-icon>
                  <span class="font-bold text-[10px] uppercase tracking-wider">ABASTECIMENTO EXTRA</span>
                </button>
              </template>
              <span>Autorização p/ Garrafas/Equipamentos</span>
            </v-tooltip>

            <v-tooltip bottom color="orange">
              <template v-slot:activator="{ on, attrs }">
                <button 
                  v-bind="attrs"
                  v-on="on"
                  @click="$router.push('/supplies-manager/create')" 
                  class="bg-orange-500 hover:bg-orange-600 text-white shadow-lg flex items-center justify-center gap-2 rounded-lg px-4 py-2 transition-all w-fit whitespace-nowrap"
                  style="width: auto !important; flex: none !important;"
                >
                  <v-icon color="white" x-small>mdi-plus</v-icon>
                  <span class="font-bold text-[10px] uppercase tracking-wider">NOVO ABASTECIMENTO</span>
                </button>
              </template>
              <span>Criar nova autorização</span>
            </v-tooltip>
            
            <div class="relative w-72">
              <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <v-icon color="white" small class="opacity-50">mdi-magnify</v-icon>
              </div>
              <v-tooltip bottom color="indigo">
                <template v-slot:activator="{ on, attrs }">
                  <input 
                    v-bind="attrs"
                    v-on="on"
                    v-model="search"
                    @keyup.enter="initialize"
                    placeholder="PESQUISAR (+ ENTER)"
                    class="bg-white/10 border border-white/20 rounded-lg py-1.5 pl-10 pr-4 text-[10px] text-white placeholder:text-white/40 focus:outline-none focus:bg-white/20 transition-all w-full uppercase tracking-widest font-bold"
                  >
                </template>
                <span>Digite a placa, cupom ou setor e aperte ENTER para buscar no histórico geral</span>
              </v-tooltip>
            </div>

            <v-btn
              icon
              small
              dark
              @click="initialize"
              class="bg-white/10 hover:bg-white/20 transition-colors"
            >
              <v-icon small>mdi-update</v-icon>
            </v-btn>
          </div>
        </div>

        <div class="p-0">
          <v-data-table
            :headers="headers"
            :items="data"
            :search="search"
            :items-per-page="10"
            :loading="loader"
            loading-text="CARREGANDO..."
            class="elevation-0"
          >
            <template v-slot:item.supply_code="{ item }">
              <span class="font-mono text-[11px] font-bold text-slate-600 bg-slate-100 px-2 py-1 rounded">
                {{ item.supply_code ? item.supply_code : item.vehicle_password }}
              </span>
            </template>

            <template v-slot:item.model_desc="{ item }">
              <div class="flex flex-col py-2" v-if="item.vehicle_id">
                <span class="text-sm font-bold text-slate-800">{{ item.vehicle_board }}</span>
                <span class="text-[10px] text-slate-500 font-medium uppercase">{{ item.brand_desc }} - {{ item.model_desc }}</span>
              </div>
              <div class="flex flex-col py-2" v-else>
                <span class="text-[10px] font-black text-orange-600 uppercase tracking-tighter bg-orange-50 px-2 py-0.5 rounded w-fit border border-orange-100">
                  {{ item.supply_extra_type == 2 ? 'EXTRA 2 (S/ VEÍCULO)' : 'EXTRA 1 (MANUAL)' }}
                </span>
                <span class="text-[9px] text-slate-400 font-bold uppercase mt-1">Lançamento Administrativo</span>
              </div>
            </template>

            <template v-slot:item.sec_name="{ item }">
               <div class="flex flex-col" v-if="item.sec_name">
                  <span class="text-xs font-bold text-slate-700 uppercase tracking-tight">{{ item.sec_name }}</span>
                  <span class="text-[9px] text-slate-400 font-bold uppercase tracking-tighter">{{ item.subsec_desc || 'GERAL' }}</span>
               </div>
               <span v-else class="text-[10px] text-slate-300 font-bold italic uppercase tracking-widest">N/A</span>
            </template>
            
            <template v-slot:item.datehour="{ item }">
              <span class="text-sm text-slate-600 font-medium">{{ convertDateTime(item.datehour) }}</span>
            </template>

            <template v-slot:item.supply_ajusted="{ item }">
              <v-chip
                x-small
                :color="item.supply_ajusted ? 'success' : 'slate-200'"
                label
                class="font-bold text-[9px]"
                :dark="item.supply_ajusted"
              >
                {{ item.supply_ajusted ? "SIM" : "NÃO" }}
              </v-chip>
            </template>

            <template v-slot:item.supply_status="{ item }">
              <v-chip
                x-small
                :color="item.supply_status === 'CONCLUIDO' ? 'success' : 'orange'"
                label
                dark
                class="font-bold text-[9px]"
              >
                {{ item.supply_status }}
              </v-chip>
            </template>

            <template v-slot:item.supply_billed="{ item }">
              <v-chip
                x-small
                :color="item.supply_billed ? 'indigo' : 'slate-300'"
                label
                class="font-bold text-[9px]"
                :dark="item.supply_billed"
              >
                {{ item.supply_billed ? "FATURADO" : "PENDENTE" }}
              </v-chip>
            </template>

            <template v-slot:item.supply_liters_stocked="{ item }">
              <span class="text-sm font-bold text-emerald-600">
                {{ item.supply_liters_stocked ? realMaskII(Number(item.supply_liters_stocked).toFixed(3)) : '0,000' }}
              </span>
            </template>

            <template v-slot:item.supply_bidding_price="{ item }">
              <span class="text-sm font-medium text-slate-700">
                {{ item.supply_bidding_price ? realMaskII(Number(item.supply_bidding_price).toFixed(3)) : '0,000' }}
              </span>
            </template>

            <template v-slot:item.total_bidding_value="{ item }">
              <span class="text-sm font-black text-slate-800">
                R$ {{ (item.supply_bidding_price && item.supply_liters_stocked) ? realMask((Number(item.supply_bidding_price) * Number(item.supply_liters_stocked)).toFixed(2)) : '0,00' }}
              </span>
            </template>

            <template v-slot:item.action="{ item }">
              <div class="flex items-center justify-end gap-1">
                <v-tooltip bottom color="purple">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" @click="[(showPassword = true), (password = item.supply_code)]">
                      <v-icon small color="purple">mdi-eye</v-icon>
                    </v-btn>
                  </template>
                  <span>Ver Senha</span>
                </v-tooltip>

                <v-tooltip bottom color="primary" v-if="item.supply_status != 'CONCLUIDO'">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" @click="$router.push(`/supplies-manager/edit/${item.supply_id}`)">
                      <v-icon small color="primary">mdi-pencil</v-icon>
                    </v-btn>
                  </template>
                  <span>Editar</span>
                </v-tooltip>

                <v-tooltip bottom color="success">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" @click="openModal(item.supply_id)">
                      <v-icon small color="success">mdi-square-edit-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>Corrigir</span>
                </v-tooltip>

                <v-tooltip bottom color="error" v-if="userGroup == 1">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon small v-bind="attrs" v-on="on" @click="deleteItem(item.supply_id)">
                      <v-icon small color="error">mdi-delete</v-icon>
                    </v-btn>
                  </template>
                  <span>Excluir</span>
                </v-tooltip>
              </div>
            </template>
          </v-data-table>
        </div>
      </div>
    </div>
    <!-- MODAL ALTERAR ABASTECIMENTO (CORRIGIR) -->
    <v-dialog v-model="dialog" width="650" persistent>
      <v-card class="rounded-2xl overflow-hidden shadow-2xl border border-slate-200">
        <div class="px-6 py-4 flex items-center justify-between" style="background-color: #333333;">
          <div class="flex items-center gap-3">
            <v-icon color="orange" small>mdi-square-edit-outline</v-icon>
            <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">CORREÇÃO DE ABASTECIMENTO</h2>
          </div>
          <v-btn icon dark small @click="dialog = false" class="hover:bg-white/10 transition-colors">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="p-8 bg-white">
          <v-form ref="form" v-model="valid">
            <div class="space-y-6">
              <!-- Data e Hora -->
              <div class="bg-slate-50 p-4 rounded-xl border border-slate-200 shadow-sm transition-all focus-within:border-orange-500 focus-within:ring-1 focus-within:ring-orange-500/10">
                <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Data e Hora do Abastecimento</label>
                <v-text-field
                  v-mask="'##/##/#### ##:##'"
                  v-model="dataAdjust.datehour"
                  placeholder="00/00/0000 00:00"
                  outlined dense hide-details
                  class="bg-white rounded-lg font-bold"
                  prepend-inner-icon="mdi-calendar-clock-outline"
                />
              </div>

              <!-- Veículo e Item -->
              <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div class="bg-slate-50 p-4 rounded-xl border border-slate-200 shadow-sm transition-all focus-within:border-orange-500 focus-within:ring-1 focus-within:ring-orange-500/10">
                  <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Veículo</label>
                  <v-autocomplete
                    v-model="dataAdjust.vehicle_id"
                    :items="vehicles"
                    item-value="vehicle_id"
                    item-text="vehicle_board"
                    placeholder="SELECIONE O VEÍCULO"
                    outlined dense hide-details
                    class="bg-white rounded-lg font-bold"
                    prepend-inner-icon="mdi-car-outline"
                    clearable
                  >
                    <template slot="item" slot-scope="{ item }">
                      <div class="flex flex-col py-2">
                        <span class="text-xs font-black text-slate-800 uppercase">{{ item.vehicle_board }}</span>
                        <span class="text-[9px] font-bold uppercase text-slate-400 tracking-wider">{{ item.brand_desc }} - {{ item.model_desc }}</span>
                      </div>
                    </template>
                  </v-autocomplete>

                  <!-- Aviso: sem veículo = abastecimento extra para distribuição -->
                  <transition name="fade">
                    <div v-if="!dataAdjust.vehicle_id" class="mt-3 bg-amber-50 border border-amber-200 rounded-lg px-3 py-2 flex items-start gap-2">
                      <v-icon small color="amber-700" class="mt-0.5 flex-shrink-0">mdi-alert-outline</v-icon>
                      <p class="text-[10px] font-bold text-amber-700 uppercase tracking-wide leading-relaxed">
                        Sem veículo → este abastecimento será convertido em <span class="font-black underline">EXTRA (TIPO 02)</span> e ficará disponível na tela de <span class="font-black">Conferências</span> para distribuição.
                      </p>
                    </div>
                  </transition>
                </div>

                <div class="bg-slate-50 p-4 rounded-xl border border-slate-200 shadow-sm transition-all focus-within:border-orange-500 focus-within:ring-1 focus-within:ring-orange-500/10">
                  <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Item/Combustível</label>
                  <v-autocomplete
                    v-model="dataAdjust.item_id"
                    :items="items"
                    item-value="item_id"
                    item-text="item_description_desc"
                    placeholder="SELECIONE O ITEM"
                    outlined dense hide-details
                    class="bg-white rounded-lg font-bold uppercase"
                    prepend-inner-icon="mdi-gas-station-outline"
                  />
                </div>
              </div>

              <!-- Valores -->
              <div class="grid grid-cols-1 md:grid-cols-3 gap-6">
                <div class="bg-slate-50 p-4 rounded-xl border border-slate-200 shadow-sm">
                  <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Litros</label>
                  <v-text-field
                    v-model="dataAdjust.supply_liters_stocked"
                    v-mask-decimal.br="3"
                    @change="calculateSubTotals"
                    outlined dense hide-details
                    class="bg-white rounded-lg font-black text-center text-emerald-600"
                  />
                </div>
                <div class="bg-slate-50 p-4 rounded-xl border border-slate-200 shadow-sm">
                  <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Preço Licitado</label>
                  <v-text-field
                    v-model="dataAdjust.supply_price_day"
                    v-mask-decimal.br="3"
                    @change="calculateSubTotals"
                    outlined dense hide-details
                    class="bg-white rounded-lg font-bold text-center text-slate-600"
                  />
                </div>
                <div class="bg-orange-50 p-4 rounded-xl border border-orange-100 shadow-sm ring-2 ring-orange-500/5">
                  <label class="block text-[10px] font-black text-orange-500 uppercase tracking-widest mb-2">Valor Total</label>
                  <v-text-field
                    readonly
                    v-model="dataAdjust.supply_value"
                    outlined dense hide-details
                    class="bg-white rounded-lg font-black text-center text-orange-600"
                    prefix="R$"
                  />
                </div>
              </div>

              <!-- Cupom e Justificativa -->
              <div class="grid grid-cols-1 gap-6">
                <div class="bg-slate-50 p-4 rounded-xl border border-slate-200 shadow-sm">
                  <label class="block text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2">Número do Cupom</label>
                  <v-text-field
                    v-model="dataAdjust.supply_coupon"
                    placeholder="000000"
                    outlined dense hide-details
                    class="bg-white rounded-lg font-bold"
                    prepend-inner-icon="mdi-ticket-outline"
                  />
                </div>

                <div v-if="dataAdjust.supply_extra" class="bg-amber-50 p-4 rounded-xl border border-amber-100 shadow-sm ring-2 ring-amber-500/5">
                  <label class="block text-[10px] font-black text-amber-500 uppercase tracking-widest mb-2">Justificativa</label>
                  <v-textarea
                    v-model="dataAdjust.justificativa"
                    placeholder="DESCREVA O MOTIVO DA CORREÇÃO..."
                    outlined dense hide-details
                    class="bg-white rounded-lg font-medium uppercase"
                    rows="2"
                    auto-grow
                  />
                </div>
              </div>
            </div>
          </v-form>
        </div>

        <div class="px-8 py-6 bg-slate-50 border-t border-slate-100 flex justify-end items-center gap-4">
          <button
            type="button"
            @click="dialog = false"
            style="background: none; border: none; cursor: pointer; white-space: nowrap;"
            class="text-slate-400 hover:text-slate-600 font-bold text-[11px] uppercase tracking-widest transition-colors"
          >
            CANCELAR
          </button>
          <button
            type="button"
            @click="ajust"
            :disabled="loader"
            style="background-color: #f37021; color: white; display: inline-flex; align-items: center; gap: 8px; border-radius: 8px; padding: 0 24px; font-size: 11px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; border: none; cursor: pointer; height: 42px; width: auto; flex-shrink: 0;"
          >
            <v-icon v-if="loader" small class="animate-spin" color="white">mdi-loading</v-icon>
            <v-icon v-else small color="white">mdi-check</v-icon>
            <span>SALVAR ALTERAÇÕES</span>
          </button>
        </div>
      </v-card>
    </v-dialog>

    <!-- MODAL SENHA -->
    <v-dialog v-model="showPassword" width="400" transition="dialog-bottom-transition">
      <v-card class="rounded-2xl overflow-hidden shadow-2xl border border-slate-200">
        <div class="p-8 text-center bg-slate-50">
          <div class="w-16 h-16 bg-emerald-100 text-emerald-600 rounded-full flex items-center justify-center mx-auto mb-6 shadow-sm">
            <v-icon size="32" color="inherit">mdi-shield-check-outline</v-icon>
          </div>
          <h3 class="text-slate-400 font-black text-[10px] uppercase tracking-[0.2em] mb-2">Código de Autorização</h3>
          <div class="relative group">
            <input
              readonly
              class="text-4xl font-black text-center w-full bg-white border-2 border-slate-200 rounded-2xl py-6 px-4 text-slate-800 shadow-xl shadow-slate-200/50 outline-none group-hover:border-emerald-400 transition-all font-mono"
              ref="copiar"
              :value="password"
            />
            <div class="absolute inset-0 bg-emerald-500/5 opacity-0 group-hover:opacity-100 transition-opacity rounded-2xl pointer-events-none"></div>
          </div>
          
          <p class="text-slate-400 text-[10px] font-bold uppercase mt-6 tracking-widest leading-relaxed">
            Utilize este código para confirmar o abastecimento no fornecedor.
          </p>
        </div>

        <div class="p-6 bg-white border-t border-slate-100">
          <button
            @click="copy"
            class="w-full h-14 rounded-xl font-black text-[11px] uppercase tracking-[0.15em] transition-all flex items-center justify-center gap-3 shadow-lg transform hover:-translate-y-1 active:translate-y-0"
            :class="copiado ? 'bg-emerald-500 text-white shadow-emerald-500/20' : 'bg-slate-900 text-white shadow-slate-900/20 hover:bg-slate-800'"
          >
            <v-icon size="18" color="white">{{ copiado ? 'mdi-check-all' : 'mdi-content-copy' }}</v-icon>
            {{ copiado ? 'CÓDIGO COPIADO!' : 'COPIAR CÓDIGO' }}
          </button>
          
          <button
            @click="showPassword = false"
            class="w-full mt-4 text-slate-400 hover:text-slate-600 font-bold text-[10px] uppercase tracking-widest py-2 transition-colors"
          >
            FECHAR JANELA
          </button>
        </div>
      </v-card>
    </v-dialog>
    
    <!-- MODAL ABASTECIMENTO EXTRA -->
    <v-dialog v-model="dialogExtra" width="600" persistent>
      <v-card class="rounded-2xl overflow-hidden shadow-2xl border border-slate-200">
        <div class="px-6 py-4 flex items-center justify-between" style="background-color: #333333;">
          <div class="flex items-center gap-3">
            <v-icon color="indigo" small>mdi-gas-station</v-icon>
            <h2 class="text-white font-bold uppercase tracking-widest text-[11px]">ABASTECIMENTO EXTRA (TIPO 02)</h2>
          </div>
          <v-btn icon dark small @click="dialogExtra = false" class="hover:bg-white/10 transition-colors">
            <v-icon small>mdi-close</v-icon>
          </v-btn>
        </div>

        <div class="p-8 bg-white">
          <div class="bg-indigo-50/50 p-4 rounded-xl border border-indigo-100 mb-8 flex items-start gap-3">
            <v-icon color="indigo" small class="mt-0.5">mdi-information-outline</v-icon>
            <p class="text-[11px] text-indigo-700 font-bold uppercase tracking-wide leading-relaxed">
              Este abastecimento não está associado a um veículo e ficará retido <span class="text-indigo-900 font-black underline">(BLOQUEADO PARA DISTRIBUIÇÃO)</span>.
            </p>
          </div>

          <v-form ref="formExtra" v-model="validExtra">
            <div class="space-y-6">
              <!-- Seleção de Município para Admin -->
              <div v-if="userGroup == 1" class="bg-slate-50 p-4 rounded-xl border border-slate-200">
                <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 block">Município (Prefeitura)</label>
                <v-autocomplete
                  v-model="dataExtra.prefecture_id"
                  :items="prefectures"
                  item-value="prefecture_id"
                  item-text="prefecture_social_name"
                  placeholder="SELECIONE A PREFEITURA"
                  @change="onExtraPrefectureChange"
                  outlined dense hide-details
                  class="bg-white rounded-lg shadow-sm font-bold uppercase"
                  prepend-inner-icon="mdi-city-variant-outline"
                />
              </div>

              <!-- Fornecedor e Item -->
              <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div class="bg-slate-50 p-4 rounded-xl border border-slate-200">
                  <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 block">Fornecedor</label>
                  <v-autocomplete
                    v-model="dataExtra.provider_id"
                    :items="providers"
                    item-value="provider_id"
                    item-text="provider_name"
                    placeholder="SELECIONE O FORNECEDOR"
                    @change="loadItemsByProvider"
                    :disabled="!dataExtra.prefecture_id"
                    outlined dense hide-details
                    class="bg-white rounded-lg shadow-sm font-bold uppercase"
                    prepend-inner-icon="mdi-store-outline"
                  />
                </div>

                <div class="bg-slate-50 p-4 rounded-xl border border-slate-200">
                  <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 block">Item / Combustível</label>
                  <v-autocomplete
                    v-model="dataExtra.item_id"
                    :items="itemsExtra"
                    item-value="item_id"
                    item-text="item_description_desc"
                    placeholder="SELECIONE O ITEM"
                    :disabled="itemsExtra.length === 0"
                    outlined dense hide-details
                    class="bg-white rounded-lg shadow-sm font-bold uppercase"
                    prepend-inner-icon="mdi-gas-station-outline"
                  />
                </div>
              </div>

              <!-- Valores Autorizados -->
              <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
                <div class="bg-slate-50 p-4 rounded-xl border border-slate-200">
                  <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 block">Litros Autorizados</label>
                  <v-text-field
                    v-model="dataExtra.supply_authorized_liters"
                    v-mask-decimal.br="3"
                    placeholder="0,000"
                    outlined dense hide-details
                    class="bg-white rounded-lg shadow-sm font-black text-center text-emerald-600"
                  />
                </div>
                <div class="bg-slate-50 p-4 rounded-xl border border-slate-200">
                  <label class="text-[10px] font-black text-slate-400 uppercase tracking-widest mb-2 block">Valor Autorizado (R$)</label>
                  <v-text-field
                    v-model="dataExtra.supply_authorized_value"
                    v-mask-decimal.br="2"
                    placeholder="0,00"
                    outlined dense hide-details
                    class="bg-white rounded-lg shadow-sm font-black text-center text-indigo-700"
                    prefix="R$"
                  />
                </div>
              </div>

              <div class="bg-indigo-50 p-4 rounded-xl border border-indigo-100 mt-2">
                <p class="text-[11px] text-indigo-600 font-bold uppercase tracking-wider flex items-center gap-2">
                  <v-icon color="indigo" x-small>mdi-information</v-icon>
                  Deixe os campos acima vazios ou com 0 para permitir Tanque Cheio.
                </p>
              </div>

              <div class="bg-amber-50 p-4 rounded-xl border border-amber-100">
                <label class="text-[10px] font-black text-amber-500 uppercase tracking-widest mb-2 block">Justificativa / Observação</label>
                <v-textarea
                  v-model="dataExtra.justificativa"
                  placeholder="INFORME O MOTIVO DESTE ABASTECIMENTO EXTRA..."
                  outlined dense hide-details
                  class="bg-white rounded-lg font-medium uppercase"
                  rows="2" auto-grow
                />
              </div>
            </div>
          </v-form>
        </div>

        <div class="px-8 py-6 bg-slate-50 border-t border-slate-100 flex justify-end items-center gap-4">
          <button
            type="button"
            @click="dialogExtra = false"
            style="background: none; border: none; cursor: pointer; white-space: nowrap;"
            class="text-slate-400 hover:text-slate-600 font-bold text-[11px] uppercase tracking-widest transition-colors"
          >
            CANCELAR
          </button>
          <button
            type="button"
            @click="saveExtra"
            :disabled="loader"
            style="background-color: #f37021; color: white; display: inline-flex; align-items: center; gap: 8px; border-radius: 8px; padding: 0 24px; font-size: 11px; font-weight: 700; letter-spacing: 0.1em; text-transform: uppercase; border: none; cursor: pointer; height: 42px; width: auto; flex-shrink: 0;"
          >
            <v-icon v-if="loader" small class="animate-spin" color="white">mdi-loading</v-icon>
            <v-icon v-else small color="white">mdi-check</v-icon>
            <span>CONFIRMAR EXTRA</span>
          </button>
        </div>
      </v-card>
    </v-dialog>

    <!-- NOTIFICAÇÕES -->
    <v-snackbar
      v-model="snack.show"
      :color="snack.color"
      timeout="4000"
      rounded="xl"
      elevation="24"
      class="mb-8"
    >
      <div class="flex items-center gap-3">
        <v-icon color="white">{{ snack.color === 'success' ? 'mdi-check-circle' : 'mdi-alert-circle' }}</v-icon>
        <span class="text-xs font-black uppercase tracking-widest">{{ snack.message }}</span>
      </div>
      <template v-slot:action="{ attrs }">
        <v-btn dark icon v-bind="attrs" @click="snack.show = false">
          <v-icon small>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import Helpers from "@/mixins/helpers.js";
import Date from "@/components/InputDate.vue";

export default {
  mixins: [Helpers],
  components: { Date },
  data() {
    return {
      search: "",
      valid: false,
      loader: true,
      copiado: false,
      password: "",
      showPassword: false,
      dialog: false,
      dialogExtra: false,
      validExtra: true,
      filter: {
        startDate: "",
        endDate: "",
        prefecture_id: null,
        provider_id: null
      },
      filterProviders: [],
      dataExtra: {
        provider_id: null,
        item_id: null,
        supply_authorized_liters: 0,
        supply_authorized_value: 0,
        justificativa: null,
        prefecture_id: null,
        supply_extra_type: 2,
      },
      itemsExtra: [],
      data: [],
      providers: [],
      items: [],
      vehicles: [],
      fieldRules: [(v) => !!v || "Este campo é requerido"],
      userGroup: null,
      prefectures: [],
      prefecture_id: null,
      snack: {
        show: false,
        message: "",
        color: "",
      },
      dataAdjust: {
        supply_id: null,
        vehicle_id: null,
        provider_id: null,
        item_id: null,
        supply_liters_stocked: 0,
        supply_price_day: 0,
        supply_coupon: null,
        supply_value: 0,
        supply_extra: false,
        justificativa: null,
      },
      headers: [
        {
          text: "Data/Hora",
          value: "datehour",
          sortable: false,
          align: "left",
        },
        { text: "Setor", value: "sec_name", sortable: false, align: "left" },
        { text: "Veículo", value: "model_desc", sortable: false },
        {
          text: "Item",
          value: "item_description_desc",
          sortable: false,
          align: "left",
        },
        {
          text: "Total de Litros",
          value: "supply_liters_stocked",
          sortable: false,
          align: "left",
        },
        {
          text: "Preço Licitado",
          value: "supply_bidding_price",
          sortable: false,
          align: "left",
        },
        {
          text: "Total Licitado",
          value: "total_bidding_value",
          sortable: false,
          align: "left",
        },
        {
          text: "Cupom",
          value: "supply_coupon",
          sortable: false,
          align: "left",
        },
        {
          text: "Status",
          value: "supply_status",
          sortable: false,
          align: "left",
        },
        {
          text: "Corrigido",
          value: "supply_ajusted",
          sortable: false,
          align: "left",
        },
        {
          text: "Faturado",
          value: "supply_billed",
          sortable: false,
          align: "left",
        },
        { text: "Ações", align: "right", value: "action", sortable: false },
      ],
    };
  },
  created() {
    this.Helpers;
    const userData = this.$store.getters.getUserData;
    this.userGroup = userData.group_id;
    this.prefecture_id = userData.table_id;

    if (this.userGroup == 1) {
      this.$http.get("/prefectures").then((r) => {
        this.prefectures = r.data;
      });
    }

    this.initialize();
    this.$root.$on("supply_updated", this.initialize);
  },
  beforeDestroy() {
    this.$root.$off("supply_updated", this.initialize);
  },
  methods: {
    initialize() {
      this.loader = true;
      this.$store.dispatch("setLoader", this.loader);
      
      let url = `/supplies/${this.prefecture_id || 0}`;
      let params = [];

      // Filtro de pesquisa genérica
      if (this.search && this.search.trim().length > 0) {
        params.push(`search=${encodeURIComponent(this.search.trim())}`);
      }

      // Filtros administrativos
      if (this.userGroup == 1) {
        if (this.filter.startDate) params.push(`startDate=${this.filter.startDate}`);
        if (this.filter.endDate) params.push(`endDate=${this.filter.endDate}`);
        if (this.filter.prefecture_id) params.push(`prefecture_id=${this.filter.prefecture_id}`);
        if (this.filter.provider_id) params.push(`provider_id=${this.filter.provider_id}`);
      }

      if (params.length > 0) {
        url += `?${params.join('&')}`;
      }

      this.$http
        .get(url)
        .then((r) => {
          this.data = r.data;
          this.loader = false;
          this.snack.color = "success";
          this.$store.dispatch("setLoader", this.loader);
        })
        .catch((e) => {
          this.loader = false;
          this.snack.show = true;
          this.snack.message = e;
          this.snack.type = "error";
          this.$store.dispatch("setLoader", this.loader);
        });
    },
    onFilterPrefectureChange(val) {
      this.filterProviders = [];
      this.filter.provider_id = null;
      if (val) {
        this.$http.get(`/providers/prefecture/${val}`).then(r => {
          this.filterProviders = r.data;
        });
      }
    },
    copy() {
      var copyTextarea = this.$refs.copiar;
      copyTextarea.select();
      try {
        var successful = document.execCommand("copy");
        if (successful) {
          this.copiado = true;
          setTimeout(() => {
            this.showPassword = false;
            this.copiado = false;
          }, 1000);
        } else {
          alert("não copiado!");
        }
      } catch (err) {
        alert(
          "Opa, Não conseguimos copiar o texto, é possivel que o seu navegador não tenha suporte, tente usar Crtl+C."
        );
      }
    },
    ajust() {
      delete this.dataAdjust.supply_authorized_liters;
      delete this.dataAdjust.supply_authorized_value;
      this.dataAdjust.supply_adjusted = true;

      // Se o veículo foi removido, converte em abastecimento extra para redistribuição
      if (!this.dataAdjust.vehicle_id) {
        this.dataAdjust.vehicle_id = null;
        this.dataAdjust.supply_extra = true;
        this.dataAdjust.supply_extra_type = 2;
        this.dataAdjust.supply_status = 'BLOQUEADO PARA DISTRIBUIÇÃO';
        this.dataAdjust.supply_confered = true;
      }

      this.$http
        .put(`/supplies/single/${this.dataAdjust.supply_id}`, this.dataAdjust)
        .then((r) => {
          this.snack.show = true;
          if (!this.dataAdjust.vehicle_id) {
            this.snack.message = "Abastecimento sem veículo salvo como EXTRA e enviado para distribuição!";
          } else {
            this.snack.message = r.data.result;
          }
          this.snack.color = "success";
          this.loader = true;
          setTimeout(() => {
            this.dialog = false;
            this.initialize();
          }, 1500);
        })
        .catch((e) => {
          this.snack.show = true;
          this.snack.message = e.message;
          this.snack.color = "error";
          this.loader = false;
          this.$store.dispatch("setLoader", false);
        });
    },
    openModal(id) {
      this.$http.get(`/supplies/single/${id}`).then((r) => {
        const supplyData = r.data[0];
        
        // Carrega veículos da prefeitura ESPECÍFICA deste abastecimento
        // Isso resolve o problema para usuários MASTER (csifrota)
        this.$http.get(`/vehicles/supplies/${supplyData.prefecture_id}`).then((v) => {
          this.vehicles = v.data;
          
          // Carrega Itens/Combustíveis usando os IDs da própria supply
          this.$http.get(`/supplies/providers/prefectures/${supplyData.provider_id}/${supplyData.prefecture_id}`).then((i) => {
            this.items = i.data;
            
            // Popula dataAdjust APÓS as listas estarem prontas e com match garantido
            this.dataAdjust = Object.assign({}, supplyData);
            this.dataAdjust.supply_liters_stocked = Number(supplyData.supply_liters_stocked || 0).toFixed(3).replace('.', ',');
            this.dataAdjust.supply_price_day = Number(supplyData.supply_price_day || supplyData.supply_bidding_price || 0).toFixed(3).replace('.', ',');
            this.dataAdjust.supply_value = Number(supplyData.supply_value || 0).toFixed(2).replace('.', ',');
            this.dataAdjust.datehour = this.convertDateTime(supplyData.datehour);
            
            this.calculateSubTotals();
            this.dialog = true;
          });
        });
      });
    },
    calculateSubTotals() {
      if (
        this.dataAdjust.supply_liters_stocked &&
        this.dataAdjust.supply_price_day
      ) {
        let subtotal =
          this.convertDecimalNumberII(this.dataAdjust.supply_price_day || 0) *
          this.convertDecimalNumberII(this.dataAdjust.supply_liters_stocked || 0);
        this.dataAdjust.supply_value = Number(subtotal).toFixed(2).replace('.', ',');
      }
    },
    deleteItem(id) {
      if (this.userGroup != 1) {
        this.snack.show = true;
        this.snack.message = "Acesso negado: apenas administradores podem excluir abastecimentos.";
        this.snack.color = "error";
        return;
      }
      let c = confirm("Deseja excluir o registro?");
      if (c) {
        this.$store.dispatch("setLoader", true);
        this.$http
          .delete(`/supplies/single/${id}`)
          .then((r) => {
            this.snack.show = true;
            this.snack.message = r.data.result;
            this.snack.color = "success";
            this.initialize();
          })
          .catch((e) => {
            this.snack.show = true;
            this.snack.message = e.message;
            this.snack.color = "error";
            this.$store.dispatch("setLoader", false);
          });
      }
    },
    openExtraModal() {
      this.dataExtra = {
        provider_id: null,
        item_id: null,
        supply_authorized_liters: 0,
        supply_authorized_value: 0,
        justificativa: null,
        prefecture_id: this.userGroup == 1 ? null : this.prefecture_id,
      };
      
      this.providers = [];
      this.itemsExtra = [];

      // Se não for admin, carrega os fornecedores automaticamente usando o ID do usuário
      if (this.userGroup != 1 && this.prefecture_id) {
        this.$http.get(`/providers/prefecture/${this.prefecture_id}`).then(r => {
          this.providers = r.data;
        });
      }

      this.dialogExtra = true;
    },
    onExtraPrefectureChange() {
      this.providers = [];
      this.dataExtra.provider_id = null;
      this.dataExtra.item_id = null;
      this.itemsExtra = [];
      
      if (this.dataExtra.prefecture_id) {
        this.$http.get(`/providers/prefecture/${this.dataExtra.prefecture_id}`).then(r => {
          this.providers = r.data;
        });
      }
    },
    loadItemsByProvider() {
      if (this.dataExtra.provider_id) {
        this.itemsExtra = [];
        this.dataExtra.item_id = null;
        const pId = this.userGroup == 1 ? this.dataExtra.prefecture_id : this.prefecture_id;
        this.$http.get(`/supplies/providers/prefectures/${this.dataExtra.provider_id}/${pId}`).then(i => {
          this.itemsExtra = i.data;
        });
      }
    },
    saveExtra() {
      const liters = parseFloat((this.dataExtra.supply_authorized_liters || "0").toString().replace(',', '.'));
      const value = parseFloat((this.dataExtra.supply_authorized_value || "0").toString().replace(',', '.'));

      if (!this.dataExtra.provider_id || !this.dataExtra.item_id) {
        this.snack.message = "Selecione o Fornecedor e o Combustível.";
        this.snack.color = "warning";
        this.snack.show = true;
        return;
      }

      this.loader = true;
      const selectedItem = this.itemsExtra.find(i => i.item_id === this.dataExtra.item_id);
      const price = selectedItem ? (parseFloat(selectedItem.item_price) || parseFloat(selectedItem.item_billing_price) || 0) : 0;

      let finalLiters = liters;
      let finalValue = value;

      if (value > 0 && liters === 0) {
        finalLiters = price > 0 ? value / price : 0;
      } else if (liters > 0 && value === 0) {
        finalValue = liters * price;
      }

      const payload = {
        ...this.dataExtra,
        supply_authorized_liters: finalLiters,
        supply_authorized_value: finalValue,
        prefecture_id: this.userGroup == 1 ? this.dataExtra.prefecture_id : this.prefecture_id,
        is_autorized: true,
        authorizer: this.$store.getters.getUserData.user_login,
      };

      this.$http
        .post("/supplies/extra", payload)
        .then((r) => {
          this.snack.show = true;
          this.snack.message = "Abastecimento Extra registrado com sucesso! (BLOQUEADO)";
          this.snack.color = "success";
          this.dialogExtra = false;
          
          if (r.data && r.data.code) {
            this.password = r.data.code;
            this.showPassword = true;
          }

          // Não listaremos extras da tela normal, logo, recarregar initialize() 
          // não fará este registro aparecer, mas pode atualizar outros registros.
          this.initialize();
        })
        .catch((e) => {
          this.snack.show = true;
          this.snack.message = e.message || "Erro ao salvar Abastecimento Extra";
          this.snack.color = "error";
          this.loader = false;
        });
    },
  },
};
</script>

<style scoped>
.top-bar {
  padding: 30px 15px;
}
.title {
  text-transform: uppercase;
  font-weight: 400;
}
.maxPage {
  width: 100%;
}
.search-field {
  margin-top: 10px;
}
.space {
  margin: 0 10px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease, transform 0.25s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
  transform: translateY(-4px);
}
</style>
